const validateEmpty = (value) => {
  const trimmed = value.trim();

  if (!trimmed) {
    return {
      isValid: false,
      errorMessage: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }

  return { isValid: true, errorMessage: '', translationKey: '' };
};

const validateName = (value) => {
  const isEmpty = validateEmpty(value);

  if (isEmpty.isValid === false) {
    return isEmpty;
  }

  const trimmed = value.trim();

  const validChars = /^[\p{L}\p{N}\s.,:․։«»(),/'-]+$/u.test(trimmed);
  if (!validChars) {
    return {
      isValid: false,
      errorMessage: 'Name contains invalid characters.',
      translationKey: 'name_contains_invalid_characters',
    };
  }

  const lettersCount = (trimmed.match(/[A-Za-zԱ-Ֆա-ֆև]/g) || []).length;

  if (lettersCount < 3) {
    return {
      isValid: false,
      errorMessage: 'Enter at least 3 letters.',
      translationKey: 'should_contain_minimum_3_letters',
    };
  }

  if (value.length > 150) {
    return {
      isValid: false,
      errorMessage: 'Maximum 150 characters allowed.',
      translationKey: 'max_150_characters_allowed',
    };
  }

  return { isValid: true, errorMessage: '', translationKey: '' };
};

const validateAddress = (value) => {
  const isEmpty = validateEmpty(value);
  const trimmed = value.trim();

  if (isEmpty.isValid === false) {
    return isEmpty;
  }

  // const validChars = /^[\p{L}\p{N}\s.,:․։«»(),/'-]+$/u.test(trimmed);

  // if (!validChars) {
  //   return {
  //     isValid: false,
  //     errorMessage: 'Address contains invalid characters.',
  //     translationKey: 'address_contains_invalid_characters',
  //   };
  // }

  const lettersCount = (trimmed.match(/[A-Za-zԱ-Ֆա-ֆև]/g) || []).length;

  if (lettersCount < 5) {
    return {
      isValid: false,
      errorMessage: 'Enter at least 5 letters.',
      translationKey: 'enter_at_least_5_letters',
    };
  }

  if (value.length > 200) {
    return {
      isValid: false,
      errorMessage: 'Maximum 200 characters allowed.',
      translationKey: 'maximum_200_characters_allowed',
    };
  }

  return { isValid: true, errorMessage: '', translationKey: '' };
};

const validateContacts = (value) => {
  const isEmpty = validateEmpty(value);

  if (isEmpty.isValid === false) {
    return isEmpty;
  }

  /// /// handle system automatically adding (\r\n) instead of (\n)
  const normalizedValue = value.replace(/\r\n/g, '\n');

  if (normalizedValue.length > 200) {
    return {
      isValid: false,
      errorMessage: 'Maximum 200 characters allowed.',
      translationKey: 'maximum_200_characters_allowed',
    };
  }

  if (normalizedValue.split('\n').length > 4) {
    return {
      isValid: false,
      errorMessage: 'Maximum 4 lines allowed.',
      translationKey: 'maximum_4_lines_allowed',
    };
  }

  return { isValid: true, errorMessage: '', translationKey: '' };
};

const validateDescription = (value) => {
  const isEmpty = validateEmpty(value);

  if (isEmpty.isValid === false) {
    return isEmpty;
  }

  /// /// handle system automatically adding (\r\n) instead of (\n)
  const normalizedValue = value.replace(/\r\n/g, '\n');

  if (normalizedValue.length > 800) {
    return {
      isValid: false,
      errorMessage: 'Maximum 800 characters allowed.',
      translationKey: 'maximum_800_characters_allowed',
    };
  }

  return { isValid: true, errorMessage: '', translationKey: '' };
};

const validateMaxDaysAheadToReserve = (value) => {
  let errorMessage = '';
  let isValid = true;
  let translationKey = '';
  const numberValue = Number(value);

  if (Number.isNaN(numberValue)) {
    isValid = false;
    errorMessage = 'Must be a number.';
    translationKey = 'must_be_a_number';
  }

  if (numberValue < 1) {
    isValid = false;
    errorMessage = 'Must be more than 1.';
    translationKey = 'must_be_more_than_1';
  }

  if (numberValue > 180) {
    isValid = false;
    errorMessage = 'Must be less than 180.';
    translationKey = 'must_be_less_than_180';
  }

  return { isValid, errorMessage, translationKey };
};

const validatePrice = (price1, price2) => {
  let errorMessage = '';
  let isValid = true;
  let translationKey = '';
  const parsedPrice1 = Number(price1);

  if (Number.isNaN(parsedPrice1)) {
    isValid = false;
    errorMessage = 'Price must be a number.';
    translationKey = 'must_be_a_number';
  }

  if (parsedPrice1 < 0) {
    isValid = false;
    errorMessage = 'Price must be a positive number.';
    translationKey = 'price_must_be_positive';
  }

  if (parsedPrice1 > 99000) {
    isValid = false;
    errorMessage = 'Price must be less than 99000 AMD.';
    translationKey = 'max_price_99000';
  }

  if (!parsedPrice1 && !Number(price2)) {
    isValid = false;
    errorMessage = 'At least one price must be provided.';
    translationKey = 'at_least_one_price_required';
  }

  return { isValid, errorMessage, translationKey };
};

const validateCourtInput = ({ fieldName, value, relatedValues }) => {
  switch (fieldName) {
    case 'name':
      return validateName(value);
    case 'address':
      return validateAddress(value);
    case 'contacts':
      return validateContacts(value);
    case 'description':
      return validateDescription(value);
    case 'maxDaysAheadToReserve':
      return validateMaxDaysAheadToReserve(value);
    case 'priceForSixtyMin':
      return validatePrice(value, relatedValues.priceForNinetyMin);
    case 'priceForNinetyMin':
      return validatePrice(value, relatedValues.priceForSixtyMin);

    default:
      return { isValid: true, errorMessage: '' };
  }
};

export default validateCourtInput;
